


import {
  computed,
  defineComponent,
  PropType,
  onMounted,
  ref,
} from '@vue/composition-api';
import { ModalPhoto } from '@/models/photoModal';
import useImageZoom from '@/composables/useImageZoom';

export default defineComponent({
  name: 'photo-modal',
  props: {
    title: {
      type: String,
      required: true,
    },
    photos: {
      type: Array as PropType<ModalPhoto[]>,
      required: true,
    },
    enableZoom: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selectedPhoto = ref<ModalPhoto | null>(null);
    const {
      zoomIn,
      zoomOut,
      resetZoom,
      canZoomIn,
      canZoomOut,
      canDrag,
      startDrag,
      onDrag,
      endDrag,
      panZoomStyle,
    } = useImageZoom({ enableZoom: props.enableZoom });
    const closePhotoModal = () => {
      emit('close-photo-modal');
    };
    const isSelectedPhoto = (photo: ModalPhoto): boolean => {
      return photo.id === selectedPhoto.value?.id;
    };
    const onClickPhoto = (photo: ModalPhoto): void => {
      selectedPhoto.value = photo;
      resetZoom();
    };
    const photoIndex = computed<number>(() => {
      if (!selectedPhoto.value) {
        return -1;
      }
      return props.photos.indexOf(selectedPhoto.value);
    });
    const isHead = computed<boolean>(() => {
      return photoIndex.value <= 0;
    });
    const isTail = computed<boolean>(() => {
      return photoIndex.value === props.photos.length - 1;
    });
    const showPrevious = () => {
      selectedPhoto.value = props.photos[photoIndex.value - 1];
      resetZoom();
    };
    const showNext = () => {
      selectedPhoto.value = props.photos[photoIndex.value + 1];
      resetZoom();
    };
    onMounted(async() => {
      selectedPhoto.value = props.photos[0];
    });
    return {
      selectedPhoto,
      isHead,
      isTail,
      closePhotoModal,
      isSelectedPhoto,
      onClickPhoto,
      showPrevious,
      showNext,
      zoomIn,
      zoomOut,
      canZoomIn,
      canZoomOut,
      canDrag,
      startDrag,
      onDrag,
      endDrag,
      panZoomStyle,
    };
  },
});
